// Permission matching rules:
//   '*'            (superuser)         matches every required key
//   '<r>.*'        (resource wildcard) matches required keys starting with '<r>.'
//   exact          matches an identical required key
export function matchesPermission(held, required) {
    if (held === '*')
        return true;
    if (held === required)
        return true;
    if (held.endsWith('.*')) {
        const resource = held.slice(0, -2); // '' if held === '.*' — never matches valid keys
        return required.startsWith(`${resource}.`);
    }
    return false;
}
export function hasPermission(held, required) {
    for (const key of held) {
        if (matchesPermission(key, required))
            return true;
    }
    return false;
}
//# sourceMappingURL=permission.js.map